import Entity from './Entity';

import ImageUrlHelper, {Options} from '../helpers/ImageUrlHelper';

export default class Background implements Entity {
  constructor(
    public id: number,
    public backgroundId: number,
    public backgroundWeatherId: number,
    public backgroundTimeZoneId: number,
    public option: string,
    public originalImageUrl: string,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }
}
